import { X } from 'lucide-react';
import type { Avaliacao } from '../../api/hooks/useAvaliacoes';
import { hasFotoReal, iniciaisAluno } from './avaliacoes-professor-shared';
import type { AvaliacoesProfessorPageContext } from './useAvaliacoesProfessorPage';

type Props = Pick<
  AvaliacoesProfessorPageContext,
  | 'avaliacaoNotas'
  | 'setAvaliacaoNotas'
  | 'notasGrid'
  | 'setNotasGrid'
  | 'alunosDaTurma'
  | 'loadingAlunosTurma'
  | 'notasQuery'
  | 'handleLancarNotas'
  | 'lancarNotas'
>;

export function AvaliacoesNotasSheet({
  avaliacaoNotas,
  setAvaliacaoNotas,
  notasGrid,
  setNotasGrid,
  alunosDaTurma,
  loadingAlunosTurma,
  notasQuery,
  handleLancarNotas,
  lancarNotas,
}: Props) {
  if (!avaliacaoNotas) return null;

  return (
    <div className="aval-notas-sheet-overlay" role="dialog" aria-modal="true">
      <div className="aval-notas-sheet">
        <div className="aval-notas-sheet-header">
          <div style={{ minWidth: 0 }}>
            <h2 className="aval-notas-sheet-title">Lancar notas</h2>
            <p className="aval-notas-sheet-sub">
              {avaliacaoNotas.titulo} · {avaliacaoNotas.turma?.nome} · Max {avaliacaoNotas.valorMaximo}
            </p>
          </div>
          <button
            type="button"
            onClick={() => setAvaliacaoNotas(null)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-muted)', padding: 4 }}
            aria-label="Fechar"
          >
            <X size={18} />
          </button>
        </div>

        {notasQuery.isLoading || loadingAlunosTurma ? (
          <div style={{ textAlign: 'center', padding: 24, color: 'var(--text-muted)' }}>
            Carregando alunos...
          </div>
        ) : alunosDaTurma.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 24, color: 'var(--text-muted)', fontSize: '0.78rem' }}>
            Nenhum aluno ativo nesta turma.
          </div>
        ) : (
          <>
            <div className="aval-notas-quick-actions">
              <button
                type="button"
                onClick={() => {
                  const novo: typeof notasGrid = {};
                  alunosDaTurma.forEach((a) => {
                    novo[a.id] = {
                      valor: String(avaliacaoNotas.valorMaximo),
                      obs: '',
                      faltou: false,
                    };
                  });
                  setNotasGrid(novo);
                }}
              >
                Nota maxima p/ todos
              </button>
              <button
                type="button"
                onClick={() => {
                  const novo: typeof notasGrid = {};
                  alunosDaTurma.forEach((a) => {
                    novo[a.id] = { valor: '', obs: '', faltou: false };
                  });
                  setNotasGrid(novo);
                }}
              >
                Limpar
              </button>
            </div>

            <div className="aval-notas-list">
              {alunosDaTurma.map((aluno) => {
                const g = notasGrid[aluno.id] || { valor: '', obs: '', faltou: false };
                const foto = aluno.fotoUrl;
                const mostraFoto = hasFotoReal(foto);
                return (
                  <div key={aluno.id} className="aval-notas-row">
                    {mostraFoto ? (
                      <img src={foto} alt="" className="aval-notas-avatar aval-notas-avatar--img" />
                    ) : (
                      <span
                        className={`aval-notas-avatar${
                          aluno.genero === 'FEMININO' ? ' aval-notas-avatar--f' : ''
                        }`}
                        aria-hidden
                      >
                        {iniciaisAluno(aluno.nome)}
                      </span>
                    )}
                    <span className="aval-notas-row-name">{aluno.nome}</span>
                    <input
                      type="number"
                      inputMode="decimal"
                      min={0}
                      max={avaliacaoNotas.valorMaximo}
                      step={0.5}
                      className="aval-notas-row-input"
                      value={g.valor}
                      onChange={(e) =>
                        setNotasGrid((prev) => ({
                          ...prev,
                          [aluno.id]: { ...g, valor: e.target.value },
                        }))
                      }
                      placeholder="--"
                      aria-label={`Nota de ${aluno.nome}`}
                    />
                  </div>
                );
              })}
            </div>

            <div className="aval-notas-sheet-actions">
              <button
                type="button"
                className="aval-form-btn-secondary"
                style={{ flex: 1 }}
                onClick={() => setAvaliacaoNotas(null)}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="aval-form-btn-primary"
                style={{ flex: 2 }}
                disabled={lancarNotas.isPending}
                onClick={() => {
                  handleLancarNotas();
                }}
              >
                {lancarNotas.isPending ? 'Salvando...' : 'Salvar notas'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
